import { useEffect, useState } from "react";
import { useIdentityClient } from "@packsize/authentication";

import { search } from "@/utils/search";

import { KioskTemplate } from "./kiosk.template";

export const Kiosk = () => {
	const { client: identityApi } = useIdentityClient();
	const [list, setList] = useState([]);
	const [filteredList, setFilteredList] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [loading, setLoading] = useState(true);
	const [failed, setFailed] = useState(false);
	const [versionNumber, setVersionNumber] = useState("0.0.0.0");

	const load = () => {
		setFailed(false);
		setLoading(true);
		setList([]);
		setFilteredList([]);

		identityApi.getKioskVersion().then((data) => {
			setVersionNumber(data.responseData);
		});

		identityApi
			.getKioskSites()
			.then((data) => {
				setList(data.responseData);
				setFilteredList(data.responseData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				setFailed(true);
			});
	};

	useEffect(() => {
		if (searchTerm.length < 3) setFilteredList(list);
		else setFilteredList(search(searchTerm, list, ["alias", "number"]));
	}, [searchTerm, list]);

	useEffect(load, [identityApi]);

	return (
		<KioskTemplate
			failed={failed}
			filteredList={filteredList}
			list={list}
			loading={loading}
			onRetry={load}
			onSearchTermChange={setSearchTerm}
			searchTerm={searchTerm}
			versionNumber={versionNumber}
		/>
	);
};
